var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueGallery',{attrs:{"images":_vm.files,"index":_vm.$store.state.galleryIndex},on:{"close":function($event){return _vm.$store.commit('closeGallery')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }